import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { BreadcrumbsItem } from '../BreadcrumbsItem/index.esm.js';
import { BreadcrumbsLink } from '../BreadcrumbsLink/index.esm.js';
import { BreadcrumbsList } from '../BreadcrumbsList/index.esm.js';
import '../BreadcrumbsItemContext.esm.js';
import '../BreadcrumbsListContext.esm.js';
import '@skatteetaten/ds-buttons';
import '@skatteetaten/ds-icons';

const Breadcrumbs = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, children }, ref)=>{
    const { t } = useTranslation('ds_navigation', {
        i18n: dsI18n
    });
    return /*#__PURE__*/ jsx("nav", {
        ref: ref,
        id: id,
        className: className,
        lang: lang,
        "data-testid": dataTestId,
        "aria-label": t('breadcrumbs.NavAriaLabel'),
        children: children
    });
});
Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.List = BreadcrumbsList;
Breadcrumbs.List.displayName = 'BreadcrumbsList';
Breadcrumbs.Item = BreadcrumbsItem;
Breadcrumbs.Item.displayName = 'BreadcrumbsItem';
Breadcrumbs.Link = BreadcrumbsLink;
Breadcrumbs.Link.displayName = 'BreadcrumbsLink';

export { Breadcrumbs };
